import React from 'react';
import Papa from 'papaparse';
import ActionButton from '../Buttons/ActionButton';
import { FaFileCsv } from 'react-icons/fa6';
import { Result, Image } from './types';
import { processImageData } from './reportUtils';

interface flattenedResult {
    rowNumber: number;
    name: string;
    status: string;
    qualityGood: number;
    qualityPoor: number;
    tumor: number;
    stroma: number;
    necrosis: number;
    lymphocyte: number;
    background: number;
    mucin: number;
}

const DownloadCSVButton = ({data, images}: {data: Result[][], images: Image[]}) => {
    const flattenedData: flattenedResult[] = data.map((results, index) => {
        const processedData = processImageData(results, images[index], index);
        return {
            rowNumber: processedData.rowNumber,
            name: processedData.name,
            status: processedData.status,
            qualityGood: processedData.qualityGood,
            qualityPoor: processedData.qualityPoor,
            tumor: processedData.tumor,
            stroma: processedData.stroma,
            necrosis: processedData.necrosis,
            lymphocyte: processedData.lymphocyte,
            background: processedData.background,
            mucin: processedData.backgroundMucin,
        };
    });
  
    const downloadCSV = () => {
        // Convert data to CSV string using papaparse
        const csv = Papa.unparse(flattenedData);

        // Create a Blob from the CSV string
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

        // Create a download link
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'data.csv'); // Set the file name

        // Append the link to the document body and click it programmatically
        document.body.appendChild(link);
        link.click();

        // Clean up and remove the link
        document.body.removeChild(link);
    };

    return (
        <ActionButton onClick={downloadCSV} text="CSV" Icon={FaFileCsv} />
    );
};

export default DownloadCSVButton;
